import { useState } from "react";
import { HAZARD_BASE, HAZARD_LABEL } from "@/lib/hazard";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const INPUT = "w-full h-9 bg-atlas-void border border-white/15 px-3 text-[12px] font-mono text-white placeholder:text-atlas-secondary/60 focus:outline-none focus:border-atlas-cyan/60 transition-colors";
export const BTN = "h-9 px-4 border text-[10px] font-mono uppercase tracking-widest transition-colors disabled:opacity-40";
export const when = (iso) => (iso ? `${iso.slice(0, 16).replace("T", " ")} UTC` : "—");

export const leadText = (h) => {
  if (h == null) return "—";
  const m = Math.round(h * 60);
  const d = Math.floor(m / 1440), hh = Math.floor((m % 1440) / 60), mm = m % 60;
  return `${d ? `${d}d ` : ""}${hh}h ${mm}m`;
};

export const KeyGate = ({ onUnlock, error, busy }) => {
  const [k, setK] = useState("");
  return (
    <form className="max-w-md flex flex-col gap-3" data-testid="manual-key-gate"
      onSubmit={(e) => { e.preventDefault(); onUnlock(k.trim()); }}>
      <label className="text-[10px] font-mono uppercase tracking-widest text-atlas-secondary">Admin key</label>
      <input type="password" className={INPUT} value={k} onChange={(e) => setK(e.target.value)} placeholder="ADMIN_KEY from backend/.env" data-testid="manual-key-input" />
      {error && <p className="text-[11px] font-mono text-atlas-red" data-testid="manual-key-error">{error}</p>}
      <button className={`${BTN} border-atlas-cyan/60 text-atlas-cyan hover:bg-atlas-cyan/10 self-start`} disabled={!k.trim() || busy} data-testid="manual-key-submit">Unlock</button>
    </form>
  );
};

export const Candidate = ({ c, active, onPick }) => (
  <button onClick={() => onPick(c)} data-testid={`manual-candidate-${c.uid}`}
    className={`w-full text-left px-3 py-2.5 border-b border-white/5 transition-colors ${active ? "bg-atlas-cyan/10" : "hover:bg-white/[0.04]"}`}>
    <div className="flex items-center gap-2 text-[9px] font-mono uppercase tracking-widest">
      <span style={{ color: HAZARD_BASE[c.hazard] }}>{HAZARD_LABEL[c.hazard] || c.hazard}</span>
      <span className="text-atlas-secondary/85">{c.status === "resolved" ? (c.outcome === "persisted" ? "still elevated" : c.outcome) : "open"}</span>
    </div>
    <div className="text-[12px] text-white/90">{c.region}</div>
    <div className="text-[10px] font-mono text-atlas-secondary">flagged {when(c.predicted_at)}</div>
  </button>
);

export const ManualRow = ({ r, onRevert }) => (
  <div className="flex flex-wrap items-start justify-between gap-3 border-b border-white/5 py-3" data-testid={`manual-row-${r.uid}`}>
    <div className="min-w-0">
      <div className="text-[12px] text-white">{r.region}</div>
      <div className="text-[10px] font-mono text-atlas-secondary">
        {r.confirmed_by?.source} · {r.confirmed_by?.title} · issued {when(r.confirmed_by?.observed_at)}
      </div>
      <div className="text-[10px] font-mono text-atlas-cyan mt-0.5">
        lead {leadText(r.lead_hours)} · {r.late ? "Confirmed (late)" : "Confirmed (hit)"}
      </div>
    </div>
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className={`${BTN} h-7 border-white/15 text-atlas-secondary hover:text-atlas-red hover:border-atlas-red/50`} data-testid={`manual-revert-${r.uid}`}>Revert</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-atlas-surface border-white/10 text-white" data-testid={`manual-revert-dialog-${r.uid}`}>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove this manual confirmation?</AlertDialogTitle>
          <AlertDialogDescription className="text-atlas-secondary">{r.region} goes back to how it was scored before ({r.manual?.previous_outcome === "persisted" ? "still elevated" : r.manual?.previous_outcome || "open"}). Its confirmed card and unsent posts are removed.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-transparent border-white/15 text-white" data-testid={`manual-revert-cancel-${r.uid}`}>Keep it</AlertDialogCancel>
          <AlertDialogAction className="bg-atlas-red/80 hover:bg-atlas-red text-white" onClick={() => onRevert(r)} data-testid={`manual-revert-confirm-${r.uid}`}>Revert</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </div>
);
